export const TOMB_TICKER = 'APEX';
export const TSHARE_TICKER = 'ASHARE';
export const TBOND_TICKER = 'ABOND';
export const FTM_TICKER = 'FTM';
export const WFTM_TICKER = 'WFTM';
export const SPOOKY_ROUTER_ADDR = '0xF491e7B69E4244ad4002BC14e878a34207E38c29';
export const ZAPPER_ROUTER_ADDR = '0x8bb1fe7a50082623b372d857b4d07911c786a3e9';
export const TAX_OFFICE_ADDR = '0x2d24cae5ce7fe5ae16d5fdc022c5f67006acf5fb';
